<template>
  <div class="full-page-wrap" >
    <div class="count-down-head py-3">
      <div class="inner-page-wrap">
        <div class="event-coundown-timer">
          <Countdown deadline="March 31, 2022"></Countdown>
        </div>
      </div>
    </div>
    <div class="inner-page-wrap mt-5">
      <div class="Prog-agenda-sec py-12">
        <div class="count-me">
          <a href="javascript:void(0);" @click="goToReg">Count Me In!</a>
        </div>
      </div>
    </div>
    <div class="publicity-video-wrap py-16">
      <h3 class="common-head text-center">WYSD Introductory Publicity Video</h3>
      <div class="inner-page-wrap mt-12">
        <div class="publicity-video-hld">
            <iframe src="https://www.youtube-nocookie.com/embed/fmGGxPq6PJ4?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <div class="footer-bottom-section">
      <div class="footer-logo">
        <img src="../assets/Images/landing/footer-logo.jpg"/>
      </div>
      <div class="footer-menu">
        <ul>
          <li><a href="">Terms &amp; Conditions</a></li>
          <li><a href="">Privacy Policy</a></li>
          <li><a href="">Contact Us</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>

import router from "@/router";
import Countdown from 'vuejs-countdown';

var self;
export default {
  components: {
   Countdown,
  },
  metaInfo() {
    return {
      title: "World Youth Skills Day (Asia-Pacific) 2022",
      meta: [
        {
          property: "og:title",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "og:url",
          content: location.host,
        },
        { property: "og:type", content: "website" },
        { property: "og:description", content: "The Main Symposium and Opening Ceremony will also provide the platform for youths and TVET stakeholders to network and explore meaningful collaborations beyond the event." },
        { property: "og:site_name", content: "Epiloge" },        
        {
          property: "og:image",
          content: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
        {
          property: "twitter:card",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:title",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:description",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:url",
          content: location.host,
        },
        {
          property: "twitter:description",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:image",
          content: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
      ],
    };
  },
  data() {
    return {
      publicEventCollection: "",
      clientId: "",
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    // self = this;
  },
  mounted() {
    self = this;
    document.title = "Programme";
    if (self.$store.state.publicEventCollection) {
      self.publicEventCollection = self.$store.state.publicEventCollection;
    }
    self.clientId = self.getClientId();
  },
  methods: {
    goToReg() {
      debugger;
      if (self.publicEventCollection) {
        if (self.clientId == "C1594240425613") {
          router.push("/reg/E1647445200290");
        } else if (self.clientId == "C1647457916091") {
          router.push("/reg/E1647459328886");
        }
      }
    },
  },
};
</script>